// Care Visit Module Routes
export default [

  // Public Visitor Registration Routes
  // {
  //   path: '/visitor-registration-test',
  //   name: 'visitor-registration-test',
  //   component: () => import('@/pages/visitor-registration/test.vue'),
  //   meta: {
  //     layout: 'client',
  //     public: true,
  //     unauthenticatedOnly: true,
  //   },
  // },
  // {
  //   path: '/visitor-registration-simple',
  //   name: 'visitor-registration-simple',
  //   component: () => import('@/pages/visitor-registration/simple.vue'),
  //   meta: {
  //     layout: 'client',
  //     public: true,
  //     unauthenticatedOnly: true,
  //   },
  // },

  // {
  //   path: '/visitor-registration',
  //   name: 'visitor-registration',
  //   component: () => import('@/pages/visitor-registration/index.vue'),
  //   meta: {
  //     layout: 'client',
  //     public: true,
  //     unauthenticatedOnly: true,
  //   },
  // },
  {
    path: '/app/care-visit',
    redirect: '/app/care-visit/dashboard',
  },

  // Routes handled through page layout
  // Dashboard Routes
  // {
  //   path: '/app/care-visit/dashboard',
  //   name: 'app-care-visit-dashboard',
  //   component: () => import('@/pages/app/care-visit/dashboard/index.vue'),
  //   meta: {
  //     subject: 'care_visits.menu.dashboard',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },

  // Visitor Management Routes
  // {
  //   path: '/app/care-visit/visitors',
  //   name: 'app-care-visit-visitors',
  //   component: () => import('@/pages/app/care-visit/visitors/index.vue'),
  //   meta: {
  //     subject: 'care_visits.visitor',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/visitors/create',
  //   name: 'app-care-visit-visitors-create',
  //   component: () => import('@/pages/app/care-visit/visitors/create.vue'),
  //   meta: {
  //     subject: 'care_visits.visitor',
  //     action: 'create',
  //     resource: 'CareVisits',
  //   },
  // },
  {
    path: '/app/care-visit/visitors/:id/edit',
    name: 'app-care-visit-visitors-edit',
    component: () => import('@/pages/app/care-visit/visitors/edit.vue'),
    meta: {
      subject: 'care_visits.visitor',
      action: 'update',
      resource: 'CareVisits',
    },
  },
  {
    path: '/app/care-visit/visitors/:id',
    name: 'app-care-visit-visitors-view',
    component: () => import('@/pages/app/care-visit/visitors/view.vue'),
    meta: {
      subject: 'care_visits.visitor',
      action: 'read',
      resource: 'CareVisits',
    },
  },

  // // Session Management Routes
  // {
  //   path: '/app/care-visit/sessions',
  //   name: 'app-care-visit-sessions',
  //   component: () => import('@/pages/app/care-visit/sessions/index.vue'),
  //   meta: {
  //     subject: 'care_visits.visitor_session',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },

  // // Security Routes
  // {
  //   path: '/app/care-visit/security/access-logs',
  //   name: 'app-care-visit-security-access-logs',
  //   component: () => import('@/pages/app/care-visit/security/access-logs.vue'),
  //   meta: {
  //     subject: 'care_visits.access_log',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },

  // // Analytics Routes
  // {
  //   path: '/app/care-visit/analytics/statistics',
  //   name: 'app-care-visit-analytics-statistics',
  //   component: () => import('@/pages/app/care-visit/analytics/statistics.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'visitor_analytics',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/analytics/peak-hours',
  //   name: 'app-care-visit-analytics-peak-hours',
  //   component: () => import('@/pages/app/care-visit/analytics/peak-hours.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'visitor_analytics',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/analytics/department',
  //   name: 'app-care-visit-analytics-department',
  //   component: () => import('@/pages/app/care-visit/analytics/department.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'visitor_analytics',
  //     resource: 'CareVisits',
  //   },
  // },

  // // Reports Routes
  // {
  //   path: '/app/care-visit/reports/daily',
  //   name: 'app-care-visit-reports-daily',
  //   component: () => import('@/pages/app/care-visit/reports/daily.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'daily_summary',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/reports/weekly',
  //   name: 'app-care-visit-reports-weekly',
  //   component: () => import('@/pages/app/care-visit/reports/weekly.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'visitor_analytics',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/reports/monthly',
  //   name: 'app-care-visit-reports-monthly',
  //   component: () => import('@/pages/app/care-visit/reports/monthly.vue'),
  //   meta: {
  //     subject: 'care_visits.reports',
  //     action: 'visitor_analytics',
  //     resource: 'CareVisits',
  //   },
  // },

  // // Location Management Routes
  // {
  //   path: '/app/care-visit/locations',
  //   name: 'app-care-visit-locations',
  //   component: () => import('@/pages/app/care-visit/locations/index.vue'),
  //   meta: {
  //     subject: 'care_visits.location',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/locations/kiosks',
  //   name: 'app-care-visit-locations-kiosks',
  //   component: () => import('@/pages/app/care-visit/locations/kiosks.vue'),
  //   meta: {
  //     subject: 'care_visits.kiosk',
  //     action: 'manage',
  //     resource: 'CareVisits',
  //   },
  // },


  // pending implementation routes
  // Visit Rules Routes
  // {
  //   path: '/app/care-visit/rules/time',
  //   name: 'app-care-visit-rules-time',
  //   component: () => import('@/pages/app/care-visit/rules/time.vue'),
  //   meta: {
  //     subject: 'care_visits.configuration',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/rules/limits',
  //   name: 'app-care-visit-rules-limits',
  //   component: () => import('@/pages/app/care-visit/rules/visitor-limits.vue'),
  //   meta: {
  //     subject: 'care_visits.configuration',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/rules/policies',
  //   name: 'app-care-visit-rules-policies',
  //   component: () => import('@/pages/app/care-visit/rules/access-policies.vue'),
  //   meta: {
  //     subject: 'care_visits.configuration',
  //     action: 'read',
  //     resource: 'CareVisits',
  //   },
  // },

  // Settings Routes
  // {
  //   path: '/app/care-visit/settings/config',
  //   name: 'app-care-visit-settings-config',
  //   component: () => import('@/pages/app/care-visit/settings/configuration.vue'),
  //   meta: {
  //     subject: 'care_visits.configuration',
  //     action: 'update',
  //     resource: 'CareVisits',
  //   },
  // },
  // {
  //   path: '/app/care-visit/settings/notifications',
  //   name: 'app-care-visit-settings-notifications',
  //   component: () => import('@/pages/app/care-visit/settings/notifications.vue'),
  //   meta: {
  //     subject: 'care_visits.configuration',
  //     action: 'update',
  //     resource: 'CareVisits',
  //   },
  // },
]
